/* eslint-disable no-throw-literal */
import apiClient from './apiClient.js';

export const getAppUsers = () => apiClient.get('/domain-users');
export const getAppUserById = (id) => apiClient.get(`/domain-users/${id}`);
export const getAppUsersAll = () => apiClient.get('/domain-users/all');
export const getAppUserAllById = (id, params) => (params ? apiClient.get(`/domain-users/domain/${id}`, { params }) : apiClient.get(`/domain-users/domain/${id}`));
export const updateAppUser = (id, data) => apiClient.put(`/domain-users/${id}`, data);
export const deleteAppUser = (id) => apiClient.delete(`/domain-users/${id}`);
export const deleteAppUserAll = (id) => apiClient.delete(`/domain-users/all/${id}`);
export const getAppUserEmailById = (email) => apiClient.get(`/domain-users/email/${email}`);

export const uploadXlsxFile = async (file, domain) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('domainId', domain);

    const response = await apiClient.post('/domain-users/import-from-xlsx', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      validateStatus: (status) => status >= 200 && status < 300, // Permitir códigos 201, 204, etc.
    });

    console.log('Respuesta del servidor:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error al subir el archivo:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export const createAppUser = async (data) => {
  try {
    const response = await apiClient.post('/domain-users', data);
    return response.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 409) {
        throw { type: 'duplicate', message: error.response.data?.error || 'El usuario ya existe.' };
      }
      throw { type: 'general', message: error.response.data?.error || 'Ha ocurrido un error, por favor intente nuevamente.' };
    }
    throw { type: 'general', message: 'Error de conexión, por favor intente nuevamente.' };
  }
};

/**
 * Actualiza el template de múltiples usuarios de forma masiva
 * @param {Array} userIds - Array de IDs de usuarios
 * @param {string} templateId - ID del template a asignar
 * @returns {Promise} Promesa con la respuesta del servidor
 */

export const massUpdateTemplate = async (userIds, templateId) => {
  try {
    const response = await apiClient.put('/domain-users/mass-update-template', {
      userIds: userIds,
      templateId: templateId,
    });
    return response.data;
  } catch (error) {
    console.error('Error en actualización masiva:', error);
    if (error.response) {
      throw { 
        type: 'general', 
        message: error.response.data?.message || 'Error al actualizar los templates de forma masiva' 
      };
    }
    throw { type: 'general', message: 'Error de conexión, por favor intente nuevamente.' };
  }
};